/**
 * The `@ember/reactive` package contains common reactive utilities
 * for tracking values and creating reactive data structures.
 *
 * @module @ember/reactive
 * @public
 */

// empty module (for now)
export default {};
